module.exports = __webpack_public_path__ + "static/media/V2_17.e2990284.png";